import {
  createInMemoryEntitlementRepository,
  createSupabaseEntitlementRepository,
  type EntitlementRepository,
} from "@/features/payment/entitlementRepository";
import {
  createNoopPurchaseEventRepository,
  createSupabasePurchaseEventRepository,
  type PurchaseEventRepository,
} from "@/features/payment/purchaseEventRepository";
import type {
  BundleEntitlementKey,
  PlayerOwner,
} from "@/features/payment/types";
import { isSupabaseConfigured } from "@/integrations/supabase/supabaseConfig";

export interface PaymentRepositories {
  readonly entitlementRepository: EntitlementRepository;
  readonly purchaseEventRepository: PurchaseEventRepository;
}

export async function createPaymentRepositories(
  playerOwner: PlayerOwner,
): Promise<PaymentRepositories> {
  if (playerOwner.ownerKind === "local" || !isSupabaseConfigured()) {
    return {
      entitlementRepository: createInMemoryEntitlementRepository(),
      purchaseEventRepository: createNoopPurchaseEventRepository(),
    };
  }
  const { getSupabaseBrowserClient } =
    await import("@/integrations/supabase/supabaseClient");
  const client = getSupabaseBrowserClient();
  return {
    entitlementRepository: createSupabaseEntitlementRepository(client),
    purchaseEventRepository: createSupabasePurchaseEventRepository(client),
  };
}

export function mergeBundleEntitlements(
  ...sources: readonly (readonly BundleEntitlementKey[])[]
): readonly BundleEntitlementKey[] {
  const merged = new Set<BundleEntitlementKey>();
  for (const source of sources) {
    for (const key of source) {
      merged.add(key);
    }
  }
  return [...merged];
}
